export function importSwiperJs() {
  return new Promise((resolve, reject) => {
    if (window.Swiper) return resolve(window.Swiper)

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css'
    document.head.appendChild(link)

    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js'
    script.onload = () => resolve(window.Swiper)
    script.onerror = reject
    document.body.appendChild(script)
  })
}
